export default __webpack_public_path__ + "static/media/status-credits.56bfb24a.svg";